(() => {
  const initialise = (section) => {
    if (!section || section.dataset.setupReady === 'true') return;
    section.dataset.setupReady = 'true';

    const button = section.querySelector('[data-sv-setup-add]');
    const status = section.querySelector('[data-sv-setup-status]');
    const dealStatus = section.querySelector('[data-sv-setup-deal-status]');
    const category = section.dataset.svSetupCategory;

    // Surfboards, softboards and bodyboards now use the shared auto-cart
    // controller. Keep this file loaded for the softboard Rubik cleanup, but
    // skip the retired manual footer controller when its controls are absent.
    if (!button || !status || !dealStatus) return;

    // Hardware saves 30% from the FIRST item on every category - there is no
    // item-count gate any more. Only free shipping is dollar-gated, and this
    // script cannot see cart totals, so it never claims shipping is unlocked.
    const updateDealStatus = () => {
      const paidCount = section.querySelectorAll('[data-sv-setup-paid]:checked:not(:disabled)').length;

      if (category === 'softboard') {
        if (paidCount > 0) {
          dealStatus.textContent = `${paidCount} setup ${paidCount === 1 ? 'item' : 'items'} selected, 30% off.`;
        } else {
          dealStatus.textContent = "Don't forget Wax - 30% off with board purchase.";
        }
        return;
      }

      if (category === 'bodyboard') {
        if (paidCount > 0) {
          dealStatus.textContent = `${paidCount} hardware ${paidCount === 1 ? 'item' : 'items'} selected, 30% off.`;
        } else {
          dealStatus.textContent = 'Add a bicep leash or bodyboard bag to save 30%.';
        }
        return;
      }

      if (paidCount > 0) {
        dealStatus.textContent = `${paidCount} ${category} ${paidCount === 1 ? 'accessory' : 'accessories'} selected, 30% off.`;
      } else {
        dealStatus.textContent = `Choose ${category} accessories to save 30%.`;
      }
    };

    section.addEventListener('change', updateDealStatus);
    updateDealStatus();

    button.addEventListener('click', async () => {
      const board = section.querySelector('[data-sv-setup-board]:checked:not(:disabled)');
      const selected = [...section.querySelectorAll('[data-sv-setup-item]:checked:not(:disabled)')];

      if (!board) {
        status.textContent = 'Choose your board size first.';
        return;
      }

      button.disabled = true;
      status.textContent = 'Adding your setup...';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: selected.map((input) => ({ id: Number(input.value), quantity: 1 }))
          })
        });

        const result = await response.json();
        if (!response.ok) throw result;

        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('product-form:cart:update', {
          bubbles: true,
          detail: { cart, response: result }
        }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        status.textContent = `${selected.length} items added to your cart.`;
        button.textContent = 'Added to cart';
      } catch (error) {
        status.textContent = error.description || error.message || 'Could not add this setup. Please try again.';
      } finally {
        button.disabled = false;
      }
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-sv-category-setup]').forEach(initialise);
  };

  const hideSoftboardRubikDuplicate = () => {
    if (!document.querySelector('.sv-category-setup--softboard')) return false;

    let hidden = false;
    document.querySelectorAll('rubik-combined-listings').forEach((listing) => {
      const root = listing.shadowRoot;
      if (!root) return;

      const groups = [...root.querySelectorAll('[data-rcl-group]')];
      const firstGroup = groups.find((group) => group.dataset.rclGroup === '0');
      if (!firstGroup) return;

      const firstSwatches = firstGroup.querySelectorAll('.rcl__swatch').length;
      const hasUsefulGroup = groups.some((group) => (
        group.dataset.rclGroup !== '0' && group.querySelectorAll('.rcl__swatch').length > firstSwatches
      ));

      if (firstSwatches <= 1 && hasUsefulGroup) {
        firstGroup.style.display = 'none';
        hidden = true;
      }
    });
    return hidden;
  };

  const initialiseRubikCleanup = () => {
    if (hideSoftboardRubikDuplicate()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (hideSoftboardRubikDuplicate() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  };

  initialiseAll();
  initialiseRubikCleanup();
  document.addEventListener('shopify:section:load', initialiseAll);
  document.addEventListener('shopify:section:load', initialiseRubikCleanup);
})();
